/**
 * スクロールボタン
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class BtnScroll {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'BtnScroll';
    this.isShow = true;
    this.winH = 0;
    this.presentScroll = 0;
    this.el = document.getElementById('p-btn-scroll');

    if (this.el) {
      this.init();
    }
  }

  /**
   * 表示前
   */
  init() {
    this.el.addEventListener('click', this.onClick.bind(this));
  }

  /**
   * ボタンクリック
   */
  onClick(e) {
    if (!this.isShow) return false;
    window.AAS.emit('scroll');
    TweenMax.to(window, 0.4, {scrollTo:{y: window.innerHeight, autoKill: false}, ease: Cubic.easeOut});
  }

  start() {
    this.resizeUpdate();
  }

  scrollable() {
    if ((this.winH * 0.1) < AnyStore.getScrollTop()) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if ((this.winH * 0.1) < _scrollY) {
      // 消す
      if (this.isShow) {
        this.isShow = false;
        TweenMax.set(this.el, {className: '+=is-hide'});
      }
    } else {
      // 表示
      if (!this.isShow) {
        this.isShow = true;
        TweenMax.set(this.el, {className: '-=is-hide'});
      }
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.winH = window.innerHeight;
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  /**
   * SCROLLボタンを消すか確認
   */
  check() {
    // 非表示
    this.isShow = false;
    TweenMax.set(this.el, {className: '+=is-hide'});
  }
}
